import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '@frontend-site/ui/components';

@Component({
    selector: 'columns-picker',
    template: `
        <ng-container>
            <p-action-button
                #menuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="menu"
                label="{{ 'ToolBar.Actions.selectColumns' | translate }}"
                iconBeforeName="columns"
                [isMenuTrigger]="true"
                iconBeforeSize="sm"
                (menuOpened)="reset()"
            ></p-action-button>

            <mat-menu #menu="matMenu" (click)="$event.stopImmediatePropagation()" class="no-padding p-menu p-menu-multiple fields-selector">
                <ng-template matMenuContent>
                    <p-picker-multi-select
                        [autoFocus]="true"
                        [list]="list | filter: checkboxColumnFilterPredicate"
                        [attr.automation-id]="'column_picker-select-field'"
                        noData="No Data Found"
                        [selectedValues]="columns"
                        (apply)="applyChange($event); menu.close.emit()"
                        (cancel)="menu.close.emit()"
                    >
                    </p-picker-multi-select>
                </ng-template>
            </mat-menu>
        </ng-container>
    `,
    styleUrls: ['./columns-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'entityColumnPicker'
})
export class ColumnsPickerComponent {
    @Input() public list: ListItem[] = [];
    @Input()
    public set columns(value: string[]) {
        this._columns = value || [];
    }
    public get columns(): string[] {
        return this._columns;
    }
    @Output()
    public columnsChange = new EventEmitter<string[]>();

    private _columns: string[] = [];
    public checkboxColumnFilterPredicate = (column: ListItem): boolean => !!column.name;

    public applyChange(columns: string[]): void {
        this.columnsChange.emit(columns || []);
    }

    public reset(): void {
        this.columns = [...this._columns];
    }
}

export interface ColumnPickerRow {
    id: string;
    name: string;
}
